// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"17":"f2b54545a80121e8","36":"52033bc78d6ae2bd","184":"6bd5afa0872baddd","799":"a33edf0fa2126cbe"}[chunkId] + ".js";
};